"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFactory;

var _react = require("react");

var INITIAL_REF_VALUE = Symbol();
/**
 * @param {Function} factory A function that's run once to generate a value
 * @return {*} The value returned by the factory function on first render
 */

function useFactory(factory) {
  var ref = (0, _react.useRef)(INITIAL_REF_VALUE);

  if (ref.current === INITIAL_REF_VALUE) {
    ref.current = factory();
  }

  return ref.current;
}

module.exports = exports.default;